// Dynamically import config based on environment variable
const getEnvironmentConfig = () => {
    const env = process.env.REACT_APP_ENV || 'development';
    
    console.log(`[Config] Loading configuration for environment: ${env}`);
    
    switch(env) {
      case 'production':
        return require('./prod.json');
      case 'development':
      default:
        return require('./dev.json');
    }
  };
  
  const constants = getEnvironmentConfig();

export const BACKEND = constants.BACKEND;
export const ALLOWED_DOCUMENT_TYPES = constants.ALLOWED_DOCUMENT_TYPES;
